import { styled } from '@mui/material';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';

export const StyledDateRangePicker = styled(DateRangePicker)(({ theme }) => ({
  fontFamily: 'Poppins',
  '& .rs-date-range-input': {
    fontSize: '14px',
  },
}));
